import PropTypes from 'prop-types'
import React from 'react'
import Input from 'components/Form/Input'
import Button from 'components/Button'
import classes from './NewRecurringOrder.scss'

import { guid } from 'helpers/index'

export const submitInputId = `submit-${guid()}`

export const NewRecurringOrder = (props) => (
  <form onSubmit={props.handleSubmit} className={classes['form']}>
    <input type='submit' id={submitInputId} className={classes.hidden} />

    <header className={classes['header']}>
      <div className={classes['header-title']}>
        Adding a Recurring Order
      </div>
    </header>

    <fieldset>
      <Input label='Name' placeholder='name' {...props.fields.name} />
    </fieldset>

    <footer className={classes['footer']}>
      <Button element={'label'} htmlFor={submitInputId} stick options={['green', 'block']}>
        Create Recurring Order
      </Button>
    </footer>
  </form>
)

NewRecurringOrder.propTypes = {
  recurring_order: PropTypes.object.isRequired,
  onSubmit: PropTypes.func, // actual submit function
  handleSubmit: PropTypes.func.isRequired, // redux-form function
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired
}

export default NewRecurringOrder



// WEBPACK FOOTER //
// ./src/components/RecurringOrders/New/NewRecurringOrder.js